function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthInsurance = function SvgHealthInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m59.7 21.2-2 1.1c2.7 5.1 3.6 10.8 2.6 16.5-2.4 14-15.8 23.3-29.7 20.9S7.4 44.1 9.6 30.3q2.85.15 5.1-1.5c3.7-2.7 5.2-8.3 5.6-10.6.1-.4-.1-.8-.4-.9-.1-.1-.2-.1-.4-.1l-.5-.1h-.3c-.4.1-.6.3-.7.7-.4 2-1.7 6.9-4.7 9.1-1.3 1-2.8 1.2-4.6 1q-2.55-.45-3.9-2.4c-2.1-3.1-1.6-8.2-1.3-10.2.1-.4-.1-.7-.4-.9-.1-.1-.2-.1-.3-.1l-.5-.1h-.4c-.3.1-.6.3-.7.7-.2 2.2-.8 8 1.8 11.8 1.1 1.6 2.5 2.6 4.3 3.2v.2c-2.3 15 7.8 29.2 22.8 31.8 15.2 2.7 29.7-7.5 32.4-22.7 1.1-6.2.1-12.4-2.8-18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 13.4c.3-2 .9-6 1.5-8.1.3-1.1 1.4-1.8 2.5-1.7H8l.3.3 1.8.6c1 .1 1.9-.5 2-1.3.1-.9-.7-1.6-1.6-1.5L8.6 2c-.2 0-.4.1-.5.3h-.7c-1.7-.1-3.2 1-3.7 2.5-.7 2.3-1.3 6.4-1.5 8.4.3 0 .7.1 1.1.2m12.3-8.1 1.9.1c.1 0 .3-.1.4-.2l.7.3c1.1.3 1.8 1.4 1.8 2.5-.1 2.2-.9 6.2-1.3 8.2.4 0 .8.1 1.1.2.4-2 1.2-6 1.3-8.3.1-1.7-1-3.2-2.6-3.6l-.7-.3c0-.2-.1-.4-.3-.5l-1.7-.9c-.8-.4-1.8 0-2 .9-.2.7.5 1.5 1.4 1.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.7,
    cy: 15.3,
    r: 1.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.4 21 .5.9c0 .1.1.1.2.1l2.5-1.4c.1 0 .1-.1.1-.2l-.6-1.1c1.7-1.9 2-4.8.6-7.1-1.7-2.8-5.4-3.6-8.1-1.9-2.8 1.7-3.6 5.4-1.9 8.1 1.4 2.4 4.2 3.3 6.7 2.6m-3.6-8.7c1.7-1 3.9-.5 4.9 1.2s.5 3.9-1.2 4.9-3.9.5-4.9-1.2-.5-3.9 1.2-4.9M49.2 21.6c-.4-.4-1.1-.6-1.7-.5-3.9.7-6.1-.7-7.8-1.7-.4-.3-.8-.5-1.2-.7-2.2-1.1-4.8-1.1-7 0-.4.2-.8.4-1.2.7-1.7 1.1-3.8 2.4-7.8 1.7-.6-.1-1.2.1-1.7.5s-.7 1-.7 1.6c.1 4.1 1.6 18.3 14.1 26.9l.7.5.7-.5c12.5-8.6 14-22.7 14.1-26.9.2-.6-.1-1.2-.5-1.6m-1.3 3.3c-.5 5.4-2.8 15.6-11.9 22.6l-1 .8-1-.8c-9-7-11.2-17.2-11.8-22.6l-.2-1.8 1.8.1c3.7.1 6-1.3 7.5-2.3.4-.2.8-.5 1.1-.6 1.6-.8 3.5-.8 5.2 0 .3.2.7.4 1.1.6 1.5 1 3.9 2.4 7.5 2.3l1.8-.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 38.1q0 .3.3.3h1.1q.3 0 .3-.3v-3.5h3.5q.3 0 .3-.3v-1.1q0-.3-.3-.3h-3.5v-3.5q0-.3-.3-.3h-1.1q-.3 0-.3.3v3.5h-3.5q-.3 0-.3.3v1.1q0 .3.3.3h3.5z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1 46.9-.3-.2c-8.8-6.9-11-16.7-11.5-22l-.1-.6h.6c4.1.2 6.7-1.4 8.2-2.4.4-.3.7-.5 1.1-.7 1.3-.6 2.7-.6 4.1 0 .4.2.6.4 1 .6l.2.1c1.6 1 4.1 2.5 8 2.3h.6l-.1.6c-.5 5.2-2.7 15.1-11.5 21.9zM24.4 25.2c.6 5.1 2.8 14.1 10.7 20.4 8-6.4 10.2-15.3 10.7-20.4-3.9 0-6.4-1.6-8-2.5l-.1-.1c-.4-.2-.7-.4-1-.6-1-.5-2.1-.5-3.2 0q-.45.15-.9.6c-1.5 1-4.1 2.7-8.2 2.6M35.1 40c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.3 6.3-6.3 6.3 2.8 6.3 6.3-2.8 6.3-6.3 6.3m0-11.6c-2.9 0-5.3 2.4-5.3 5.3s2.4 5.3 5.3 5.3 5.3-2.4 5.3-5.3-2.4-5.3-5.3-5.3",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgHealthInsurance;